
import Logo from '@/components/shared/logo-simplified'
import DropdownUser from '@/components/header/dropdown/user'
import AuthModal from '@/components/auth'

export default {
  components: {
    Logo,
    DropdownUser,
    AuthModal,
  },
}
